module.exports = __webpack_public_path__ + "1998_1999.jpg";